import { useQuery } from '@tanstack/react-query';

import { handleNucleusResponse, SubscriptionPlanService } from '../../services';
import type { SubscriptionPlan } from '@billx/types';

export const useSubscriptionPlans = () => {
  const QUERY_KEY = ['subscriptionPlans'];
  const query = useQuery<SubscriptionPlan[], Error>({
    queryKey: QUERY_KEY,
    queryFn: async () => {
      const response = await SubscriptionPlanService.getActivePlans();
      return handleNucleusResponse(response).data;
    },
  });

  const { data: plans = [], ...restQuery } = query;
  return {
    // Query data
    plans,
    ...restQuery,
  };
};
